import * as rmd from 'material-ui';
import React, { Component } from 'react';
import styled from 'styled-components';
import ImageUploaderContainer from 'dash-front/components/ImageUploaderContainer';
import _ from 'lodash';

const Label = styled.label`
    color: rgba(0, 0, 0, 0.3);
    font-size: 12px;
    display: block;
    margin-bottom: 10px;
`;
import { IconButton, FlatButton } from 'material-ui';
import auth from 'dash-front/auth';
import config from 'cfg';
import { compose, lifecycle, withStateHandlers } from 'recompose';
import IconDelete from 'material-ui/svg-icons/navigation/close';
import IconAdd from 'material-ui/svg-icons/content/add-circle-outline';
import moment from 'moment';

const AreaManipulations = ({ id, onChange, name, ...props }) => (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', margin: '10px 0 ' }}>
        {/* <pre>{JSON.stringify(props, null, 4)}</pre> */}

        <img src={props.url} style={{ width: 50, height: 50, objectFit: 'cover' }} />
        <span style={{ padding: 10, flexGrow: 1 }}>{name}</span>
        <IconButton
            onClick={e => {
                onChange(id, null);
            }}
        >
            <IconDelete color="#fff" />
        </IconButton>
        {/* <rmd.FlatButton
            label="Remove"
            onClick={() => {
                onChange(id, null);
            }}
        /> */}
    </div>
);

class DNDBgrPicker extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = props[props.propKey] || {};
        this.state.revision = 0;
    }

    componentWillMount() {
        window.addEventListener('WDPBgrManipulations', this.onManipulation, false);
    }

    onManipulation = e => {
        // if (this.props.propKey !== e.detail.id) return;

        this.props.onChange(e.detail.id, {
            ..._.get(this.props, `${e.detail.id}`, {}),
            ...e.detail.values,
        });

        // upstream changes
    };

    componentWillReceiveProps = nextProps => {
        // console.log('WHAT', nextProps);
    };

    render() {
        const areas = _.chain(this.props)
            .keys()
            .filter(k => k.indexOf('area') === 0 && this.props[k] && !_.isEmpty(this.props[k]))
            .map(key => ({ key, ...this.props[key] }))
            .value();

        const dnd = this.props[this.props.propKey] || {};

        return (
            <div>
                {areas.map((area, index) => (
                    <AreaManipulations
                        key={area.key}
                        id={area.key}
                        {...area}
                        name={`${index}. layer`}
                        onChange={this.props.onChange}
                    />
                ))}

                {areas.length < 5 && (
                    <rmd.FlatButton
                        icon={<IconAdd />}
                        label="Add custom background"
                        onClick={() => {
                            this.props.onChange(`area${areas.length + 1}`, {
                                init: 1,
                            });
                        }}
                    />
                )}
                <rmd.Divider style={{ marginTop: 15, marginBottom: 15 }} />
                {areas.length >= 2 && (
                    <div>
                        <rmd.SelectField
                            floatingLabelText="Direction"
                            value={dnd.direction || 'row'}
                            onChange={(e, index, direction) => {
                                this.props.onChange(this.props.propKey, { ...dnd, direction });
                            }}
                        >
                            {['row', 'column'].map(t => {
                                return <rmd.MenuItem key={t} value={t} primaryText={t} />;
                            })}
                        </rmd.SelectField>

                        <rmd.Toggle
                            label="Split with border between"
                            checked={dnd.border}
                            style={{ marginTop: 15 }}
                            onToggle={(e, isChecked) => {
                                this.props.onChange(this.props.propKey, { ...dnd, border: isChecked });
                            }}
                        />
                        <rmd.Divider style={{ marginTop: 15, marginBottom: 15 }} />
                    </div>
                )}

                <FlatButton
                    label="Upload image"
                    style={{ width: '100%' }}
                    onClick={() => {
                        this.setState({
                            showUploader: true,
                        });
                    }}
                />

                {this.state.showUploader && (
                    <ImageUploaderContainer
                        onCopy={url => {
                            alert(url);
                        }}
                        onClose={() => {
                            this.setState({
                                showUploader: false,
                                revision: this.state.revision + 1,
                            });
                        }}
                        modal
                        showGallery={false}
                    />
                )}
            </div>
        );
    }
}

export default DNDBgrPicker;



/** WEBPACK FOOTER **
 ** ../src/dash/front/components/pickers/DNDBgrPicker.js
 **/